if (!customElements.get('ecomhard-facets-toggle')) {
  class EcomhardFacetsToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.collection = this.closest('.collection');

      if (!this.button || !this.collection) return;

      this.onToggle = this.onToggle.bind(this);
      this.button.addEventListener('click', this.onToggle);
      this.setExpanded(false);
    }

    disconnectedCallback() {
      if (this.button && this.onToggle) {
        this.button.removeEventListener('click', this.onToggle);
      }
    }

    onToggle() {
      const expanded = !this.collection.classList.contains('ecomhard-facets-expanded');
      this.setExpanded(expanded);
    }

    setExpanded(expanded) {
      this.collection.classList.toggle('ecomhard-facets-expanded', expanded);
      this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      this.setAttribute('data-expanded', expanded ? 'true' : 'false');

      if (!expanded) {
        this.collection.querySelectorAll('.facets__horizontal-dropdown[open]').forEach((dropdown) => {
          dropdown.removeAttribute('open');
          dropdown.removeAttribute('data-state');
          const summary = dropdown.querySelector('.facets__horizontal-summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        });
      }
    }
  }

  customElements.define('ecomhard-facets-toggle', EcomhardFacetsToggle);
}
